import React from 'react'
import { useTranslation } from 'react-i18next'
import { OmInput } from '@owma/kit'
import styles from './EventEditor.module.scss'
import noteIcon from 'assets/images/calendar/note-icon.svg'

interface EditEventData {
  description: string
  isMyEvent: boolean
}

interface DescriptionSelectorProps {
  editEventData: EditEventData
  onDescriptionChange: (description: string) => void
}

const DescriptionSelector: React.FC<DescriptionSelectorProps> = ({
  editEventData,
  onDescriptionChange,
}) => {
  const { t } = useTranslation()

  const handleChange = (value: string) => {
    onDescriptionChange(value)
  }

  return (
    <div className={styles.descriptionWrapper}>
      <img src={noteIcon} alt="Description" className={styles.titleIcon} />
      <div
        className={`${styles.descriptionContent} ${!editEventData.isMyEvent ? styles.dimmed : ''}`}
      >
        <OmInput
          multiline
          className={styles.descriptionInput}
          placeholder={t('calendar.edit.addDescription')}
          value={editEventData.description}
          onChange={handleChange}
          autoSize={{ minRows: 3, maxRows: undefined }}
        />
      </div>
    </div>
  )
}

export default DescriptionSelector
